import React from 'react';
import styled from 'styled-components'; 

const AddressList = ({ 
  addresses = [], selectedAddress, handleAddress 
}) => { 
  return ( 
  <Wrapper> 
    <div className="existing-address"> 
      <h3>Delivery / Shipping Address</h3> 
      <p className="address-subtext"> Select from Existing addresses </p> 
      <ul className="address-list"> 
        {addresses.map((addr, idx) => ( 
          <li key={addr._id || idx} className="address-item" > 
              <div className="address-left"> 
                <input type="radio" name="address" className="address-radio" 
                checked={selectedAddress === addr} 
                onChange={() => handleAddress(idx)} 
                /> <div className="address-details"> 
                
                <p className="address-name"> {addr.name} </p> 
                <p className="address-street"> {addr.street_add} </p> 
                <p className="address-pin"> {addr.zipcode} </p> 
                </div> 
            </div> 
            <div className="address-right"> 
              <p className="address-city"> City: {addr.city} </p> 
              <p className="address-country"> {addr.country} </p> 
              <p className="address-phone"> +({addr.isdCode}) - {addr.phone} </p>
              </div> 
              </li> 
              ))} 
              </ul> 
              </div> 
              </Wrapper> 
              ); 
            }; 
            const Wrapper = styled.section` 
            
            .address-subtext { 
            font-size: 1.2rem; 
            line-height: 1.5; 
            color: #4b5563; 
            margin-top: 0.5rem; 
            } 
            .address-list { 
            list-style: none; 
            padding: 0; 
            margin: 1rem 0; 
            } 
            .address-item { 
            display: flex; 
            justify-content: space-between; 
            gap: 1.5rem; 
            padding: 1.25rem; 
            border: 2px solid #e5e7eb; 
            border-radius: 6px; 
            margin-bottom: 1rem; 
            align-items: center; 
            flex-wrap: wrap; 
            } 
            .address-left { 
            display: flex; 
            gap: 1rem; 
            flex: 1; 
            align-items: center; 
            } 
            .address-radio { 
            width: 1rem; 
            height: 1rem; 
            } 
            .address-details { 
            flex: 1; 
            } 
            .address-name { 
            font-size: 1.3rem; 
            font-weight: 600; 
            color: #111827; 
            } 
            
            .address-street, .address-pin { 
            font-size: 1.1rem; 
            color: #6b7280; 
            margin-top: 0.2rem; 
            } 
            .address-right { 
            display: flex; 
            flex-direction: column; 
            align-items: flex-end; 
            justify-content: center; 
            min-width: 120px; 
            } 
            
            
            .address-phone { 
            font-size: 1.1rem; 
            color: #111827; 
            } 
            
            .address-city { 
            font-size: 1.1rem; 
            color: #6b7280; 
            
            } 
            
            
            @media (max-width: ${({ theme }) => theme.media.mobile}) {
             .address-item { 
             flex-direction: column; 
             align-items: flex-start;
             }
             
             .address-left { 
             width: 100%; 
             } 
             
             
             .address-right {
             width: 100%; 
             align-items: flex-start; 
             margin-top: 0.5rem; 
             } 
             
             .address-name { 
             font-size: 1rem; 
             } 
             
             .address-street, .address-pin, .address-phone, .address-city {
              font-size: 0.85rem; 
              } 
              } 
              `;
                
              export default AddressList;